// * FUNCION PARA GUARDAR LAS AREAS.
export const saveAreaOrganizacional = ({ areaId, areaOrganizacionales, setValue }) => {
  // * OBTENER PADRE DEL AREA SELECCIONADA.
  const padre = areaOrganizacionales.find((x) => x.id === areaId)?.padre ?? 1;
  const areaMaxima = areaOrganizacionales.find((x) => x.id === areaId)?.areaMaxima ?? 1;

  setValue('empleado.areaOrganizacionalId', areaId);
  setValue('empleado.areaOrganizacionalPadreId', padre);
  setValue('empleado.areaMaxima', areaMaxima);
};
